import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { safetyTips } from '@/mocks/site';

export default function ChecklistSection() {
  return (
    <section className="bg-secondary-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="出发之前"
          title="四条底线，先记住再看机会"
          desc="骗局的共同点是让你来不及思考。把这四条放在前面，很多风险在第一步就能被拦下。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {safetyTips.map((tip, index) => (
            <div
              key={tip.title}
              className="flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className={`${tip.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-3xl font-black text-secondary-200">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start gap-4 rounded-lg border border-secondary-300 bg-background-50 p-5 sm:flex-row sm:items-center sm:justify-between md:p-6">
          <p className="flex items-center gap-3 text-sm text-foreground-700">
            <i className="ri-checkbox-multiple-line text-xl text-secondary-600" aria-hidden="true"></i>
            把九项核查清单逐条打勾，未确认的项保持空白，直到全部确认再考虑出发。
          </p>
          <Link
            to="/archives/overseas-job-checklist"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            查看自检清单
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}